<template>
    <section id="brand-animation">
        <h2 v-html="title" />
        <div class="mb-1 mb-lg-2 ml-md-1">
            <div class="d-flex">
                <ul class="advantage-list row p-0">
                    <li v-for="(advantage, index) in brandAdvantages" :key="'adv-' + index" class="col-12 pb-1 px-1 pl-md-0 pr-md-4">
                        <div class="advantage-item p-1 p-md-0">
                            <span class="advantage-icon pr-1" :class="[advantage.icon]" aria-hidden="true" />
                            <div class="mt-1 mt-md-0 mb-md-2">
                                <p class="lead mb-0 py-0" v-html="advantage.title" />
                                <p class="mb-0 py-0" v-html="advantage.text" />
                                <ob1-liens
                                    v-if="advantage.url"
                                    class="pb-0"
                                    :is-mini="true"
                                    :text="advantage.labelUrl"
                                    :href="advantage.url"
                                    :with-arrow="true"
                                />
                            </div>
                        </div>
                    </li>
                </ul>
                <img
                    class="advantages-image d-none d-md-flex"
                    loading="lazy"
                    alt=""
                    :src="image"
                >
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "BrandAnimationSection",
    props: {
        title: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        brandAdvantages: {
            type: Array,
            required: true
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables';

.advantages-image {
    object-fit: contain;
    object-position: top;
}

ul.advantage-list li {
    list-style:none;
}

.advantage-item {
    border: 1px solid #cccccc;
    max-width: 41.5rem;
    height: 100%;
    text-decoration: none;

    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        display: flex;
        border: none;
    }

    .advantage-icon {
        margin-right: px-to-rem(15);
        font-size: px-to-rem(32);
        font-weight: 400;
    }
}
</style>
